export const SPRING_DEFAULT = { type: 'spring', bounce: 0, duration: 0.4 };

export const SPRING_SHEET = { type: 'spring', bounce: 0.2, duration: 0.3 };

export const SPRING_MOMENTUM = { type: 'spring', bounce: 0.2, duration: 0.4 };

export const SPRING_PRESS = { type: 'spring', bounce: 0, duration: 0.18 };

export const REDUCED_MOTION_TRANSITION = { type: 'tween', duration: 0.16, ease: 'easeOut' };

/** ponytail: UIKit-style deceleration projection (px), not a physics sim */
export function project(initialVelocity, decelerationRate = 0.998) {
  return (initialVelocity / 1000) * decelerationRate / (1 - decelerationRate);
}

export function rubberband(overshoot, dimension, constant = 0.55) {
  return (overshoot * dimension * constant) / (dimension + constant * Math.abs(overshoot));
}

export function nearestSnapPoint(projectedValue, snapPoints) {
  if (!snapPoints.length) return projectedValue;
  let closest = snapPoints[0];
  let minDist = Math.abs(projectedValue - closest);
  for (let i = 1; i < snapPoints.length; i += 1) {
    const dist = Math.abs(projectedValue - snapPoints[i]);
    if (dist < minDist) {
      minDist = dist;
      closest = snapPoints[i];
    }
  }
  return closest;
}
